import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const RedirectPage = () => {
    const { type, id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchEncryptedId = async () => {
            try {
                const response = await window.apiClient(`/redirect/get/${type}/${id}`);
                if (response.data.encrypted_id) {
                    navigate(`/article/${response.data.encrypted_id}`, { replace: true });
                } else {
                    navigate("/404", { replace: true });
                }
            } catch (error) {
                console.error("Gagal mendapatkan encrypted ID:", error);
                navigate("/404", { replace: true });
            }
        };

        fetchEncryptedId();
    }, [type, id, navigate]);

    return <p>Loading...</p>; // Bisa diganti dengan animasi loading
};

export default RedirectPage;
